import React from 'react';
import ReactLoading from 'react-loading';

type Props = {
    color: string;
};

export default function Loading({ color }: Props) {
    return (
        <React.Fragment>
            <div className="loading-wrapper">
                <div className="loading-fullpage--content">
                    <div className="text-bubble">{'Načítání...'}</div>
                    <ReactLoading type="cubes" color={color} height={90} width={90} />
                </div>
            </div>
        </React.Fragment>
    );
}
